import { render } from "./DebtorsCard.vue?vue&type=template&id=7e8bb544"
import script from "./DebtorsCard.vue?vue&type=script&lang=js"
export * from "./DebtorsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__